import { motion } from "framer-motion";

export default function HankoSeal({ size = 96, className = "", animate = true }) {
  const seal = (
    <img
      src="/sora-logo.png"
      alt="Sigiliul SORA"
      style={{ height: size, width: "auto" }}
      className="drop-shadow-[0_10px_24px_rgba(211,47,47,0.25)]"
    />
  );
  if (!animate) return <div className={className}>{seal}</div>;
  return (
    <motion.div
      className={className}
      initial={{ scale: 1.6, opacity: 0, rotate: -18 }}
      animate={{ scale: 1, opacity: 1, rotate: -6 }}
      transition={{ type: "spring", stiffness: 200, damping: 15, delay: 1.15 }}
    >
      {seal}
    </motion.div>
  );
}
